export interface ProductMedia {
  coverImage: string;
  videoURL?: string;
  additionalImages: string[];
}

export const getEmptyProductMedia = (): ProductMedia => ({
  coverImage: '',
  additionalImages: [],
});

export const productMediaFromResponse = (responseData: any): ProductMedia => ({
  coverImage: responseData.cover_image ?? '',
  videoURL: responseData.video_url,
  additionalImages: responseData.additional_images ?? [],
});
